import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppMeeting from "./AppMeeting";
import { CommonProvider } from "./hooks/CommonContext";
import { ConditionProvider } from "./hooks/ConditionContext";
import SocketInit from "hooks/SocketInit";
function App() {
  return (
    <BrowserRouter>
      <ConditionProvider>
        <Routes>
          <Route
            path="/:interview_id"
            element={
              <CommonProvider>
                <SocketInit>
                  <AppMeeting />
                </SocketInit>
              </CommonProvider>
            }
          />
        </Routes>
      </ConditionProvider>
    </BrowserRouter>
  );
}

export default App;
